export default __webpack_public_path__ + "static/4-1ea2b111d66a479f38b14ac289fa39ee.jpg";